// store/college/student-management/store/_reducer.js
import * as types from './_actionTypes';

const initialState = {
  students: [],
  studentsForExport: [],
  exportLoading: false,
  studentsProgress: [],
  degrees: [],
  fetchingDegrees: false,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  },
  selectedStudents: [],
  filters: {
    search: '',
    status: 'all',
    course: '',
    semester: 'all',
    sortBy: 'created_at',
    sortOrder: 'desc',
      degree: 'all',
    batch: ''

  },
  loading: false,
  uploading: false,
  downloadingTemplate: false,
  actionLoading: {}, // For individual student actions
  uploadResult: null,
  smsResult: null,
  enrollmentResult: null,
  error: null,
  progressLoading: false,
  searchResults: []
};

const collegeStudentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Students
    case types.FETCH_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students || action.payload,
        pagination: action.payload.pagination || state.pagination,
        error: null
      };
      
      case types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_REQUEST:
      return {
        ...state,
        exportLoading: true,
        error: null
      };
    case types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_SUCCESS:
      console.log('Reducer FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_SUCCESS action.payload:', action.payload);
      return {
        ...state,
        // The export reuses FETCH_STUDENTS_REQUEST (which sets loading: true),
        // so clear loading here too or the table spinner never stops.
        loading: false,
        exportLoading: false,
        studentsForExport: action.payload.studentsForExport || action.payload,
        error: null
      };
    case types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_FAILURE:
      return {
        ...state,
        loading: false,
        exportLoading: false,
        error: action.payload
      };

    // Upload Students
    case types.UPLOAD_STUDENTS_REQUEST:
      return {
        ...state,
        uploading: true,
        uploadResult: null,
        error: null
      };

    case types.UPLOAD_STUDENTS_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploadResult: action.payload,
        error: null
      };

    case types.UPLOAD_STUDENTS_FAILURE:
      return {
        ...state,
        uploading: false,
        error: action.payload
      };

    // Download Template
    case types.DOWNLOAD_TEMPLATE_REQUEST:
      return {
        ...state,
        downloadingTemplate: true,
        error: null
      };

    case types.DOWNLOAD_TEMPLATE_SUCCESS:
      return {
        ...state,
        downloadingTemplate: false,
        error: null
      };

    case types.DOWNLOAD_TEMPLATE_FAILURE:
      return {
        ...state,
        downloadingTemplate: false,
        error: action.payload
      };

    // Create Student
    case types.CREATE_STUDENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.CREATE_STUDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        students: [action.payload, ...state.students],
        error: null
      };

    case types.CREATE_STUDENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update Student
    case types.UPDATE_STUDENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.UPDATE_STUDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        students: state.students.map(student =>
          student.id === action.payload.id || student.user_id === action.payload.user_id
            ? action.payload
            : student
        ),
        error: null
      };

    case types.UPDATE_STUDENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

 // Pagination Actions
    case types.SET_PAGE:
  
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload.page
        }
      };
      
    case types.SET_PAGE_SIZE:
         console.log('Reducer action.payload in SET_PAGE_SIZE:', action.payload);
      return {
        ...state,
        pagination: {
          ...state.pagination,
          limit: action.payload.pagesize,
          page: 1 // Reset to first page
        }
        
      };
      
    case types.SET_SEARCH:
      return {
        ...state,
        filters: {
          ...state.filters,
          search: action.payload.search
        },
        pagination: {
          ...state.pagination,
          page: 1 // Reset to first page when searching
        }
      };
      
    case types.SET_STATUS_FILTER:
      console.log('Reducer action.payload in SET_STATUS_FILTER:', action.payload);
      return {
        ...state,
        filters: {
          ...state.filters,
          status: action.payload.status,
        },
        pagination: {
          ...state.pagination,
          page: 1 // Reset to first page when filtering
        }
      };
      
    case types.SET_SORT:
      return {
        ...state,
        filters: {
          ...state.filters,
          sortBy: action.payload.sortBy,
          sortOrder: action.payload.sortOrder
        },
        pagination: {
          ...state.pagination,
          page: 1 // Reset to first page when sorting
        }
      };

    // Toggle Student Status
    case types.TOGGLE_STUDENT_STATUS_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload.studentId]: true
        },
        error: null
      };

    case types.TOGGLE_STUDENT_STATUS_SUCCESS:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload.studentId]: false
        },
        students: state.students.map(student =>
          student.id === action.payload.studentId
            ? { 
                ...student, 
                status: action.payload.isActive ? 'active' : 'suspended' 
              }
            : student
        ),
        error: null
      };

    case types.TOGGLE_STUDENT_STATUS_FAILURE:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload.studentId]: false
        },
        error: action.payload
      };

    // Fetch Students Progress
    case types.FETCH_STUDENTS_PROGRESS_REQUEST:
      return {
        ...state,
        progressLoading: true,
        error: null
      };

    case types.FETCH_STUDENTS_PROGRESS_SUCCESS:
      return {
        ...state,
        progressLoading: false,
        studentsProgress: action.payload,
        error: null
      };

    case types.FETCH_STUDENTS_PROGRESS_FAILURE:
      return {
        ...state,
        progressLoading: false,
        error: action.payload
      };

    // Retry Credentials SMS
    case types.RETRY_CREDENTIALS_SMS_REQUEST:
      return {
        ...state,
        loading: true,
        smsResult: null,
        error: null
      };

    case types.RETRY_CREDENTIALS_SMS_SUCCESS:
      return {
        ...state,
        loading: false,
        smsResult: action.payload,
        error: null
      };

    case types.RETRY_CREDENTIALS_SMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Bulk Enroll
    case types.BULK_ENROLL_REQUEST:
      return {
        ...state,
        loading: true,
        enrollmentResult: null,
        error: null
      };

    case types.BULK_ENROLL_SUCCESS:
      return {
        ...state,
        loading: false,
        enrollmentResult: action.payload,
        selectedStudents: [], // Clear selected students after enrollment
        error: null
      };

    case types.BULK_ENROLL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Search Students
    case types.SEARCH_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.SEARCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        error: null
      };

    case types.SEARCH_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Legacy Blacklist (maps to toggle status)
    case types.BLACKLIST_STUDENT_REQUEST:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: true
        },
        error: null
      };

    case types.BLACKLIST_STUDENT_SUCCESS:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        },
        students: state.students.map(student =>
          student.id === action.payload
            ? { ...student, status: 'blacklisted' }
            : student
        ),
        error: null
      };

      case types.FETCH_DEGREES_REQUEST:
  return {
    ...state,
    fetchingDegrees: true
  };

case types.FETCH_DEGREES_SUCCESS:
  return {
    ...state,
    degrees: action.payload,
    fetchingDegrees: false
  };

case types.FETCH_DEGREES_FAILURE:
  return {
    ...state,
    fetchingDegrees: false,
    error: action.payload
  };

case types.SET_DEGREE_FILTER:
  return {
    ...state,
    filters: {
      ...state.filters,
      degree: action.payload.degree
    }
  };

case types.SET_BATCH_FILTER:
  return {
    ...state,
    filters: {
      ...state.filters,
      batch: action.payload.batch
    }
  };
    case types.BLACKLIST_STUDENT_FAILURE:
      return {
        ...state,
        actionLoading: {
          ...state.actionLoading,
          [action.payload]: false
        },
        error: action.payload
      };

    // UI State Management
    case types.SET_SELECTED_STUDENTS:
      return {
        ...state,
        selectedStudents: action.payload
      };

    case types.CLEAR_UPLOAD_RESULT:
      return {
        ...state,
        uploadResult: null,
        smsResult: null,
        enrollmentResult: null,
        error: null
      };

    case types.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };

      case types.SET_SEMESTER_FILTER:
  return {
    ...state,
    filters: {
      ...state.filters,
      semester: action.payload.semester
    }
  };
    default:
      return state;
  }
};

export default collegeStudentReducer;